import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-72465d0b"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "project-list-model",
  ref: "userNewModel"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "iconfont icon-close" }, null, -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "item" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "require lable" }, "所在街道：", -1))
const _hoisted_6 = { class: "item" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "require lable" }, "企业名称：", -1))
const _hoisted_8 = { class: "item" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "require lable" }, "项目编号：", -1))
const _hoisted_10 = { class: "item" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "require lable" }, "工程项目名称：", -1))
const _hoisted_12 = { class: "item" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "require lable" }, "工程项目内容：", -1))
const _hoisted_14 = { class: "item" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "require lable" }, "完成情况：", -1))
const _hoisted_16 = { class: "item" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "require lable" }, "开始时间：", -1))
const _hoisted_18 = { class: "item" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "require lable" }, "结束时间：", -1))

import {
  reactive, withDefaults, ref, watch, computed,
} from 'vue';
import { useStore, } from 'vuex';
import moment, { Moment, } from 'moment';
import {
  Modal, Button, Input, Select, DatePicker, ConfigProvider, message,
} from 'ant-design-vue';
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import { addOrUpdateProject, } from '../../projectListReq';

interface Props {
  createVisible?: boolean,
  itemInfo?: any,
  streetList: any,
  statusList:any,
}
interface FormState {
  street: string | undefined,
  companyName: string | undefined,
  projectNumber: string | undefined,
  projectName: string | undefined,
  projectContent: string | undefined,
  completion: string | undefined,
  startTime: Moment,
  endTime: Moment,
}


export default /*#__PURE__*/_defineComponent({
  props: {
    createVisible: { type: Boolean, default: false },
    itemInfo: { default: Object },
    streetList: null,
    statusList: { default: Array }
  },
  emits: ['cancal', 'save',],
  setup(__props: any, { emit: emits }) {

const props = __props as { createVisible: boolean, itemInfo: any, streetList: any, statusList:any }

const store = useStore();

const { Option, } = Select;



// 添加弹窗显隐
const addVisible = ref<boolean>(false);
// 删除弹窗显隐
const delVisible = ref<boolean>(false);

const Form = reactive<FormState>({
  street: '',
  companyName: '',
  projectNumber: '',
  projectName: '',
  projectContent: '',
  completion: '',
  startTime: moment(),
  endTime: moment(),
});

const resetData = () => ({
  street: '',
  companyName: '',
  projectNumber: '',
  projectName: '',
  projectContent: '',
  completion: '',
  startTime: moment(),
  endTime: moment(),
});

const cancal = (str: string): void => {
  if (str === 'add') {
    addVisible.value = false;
  } else if (str === 'del') {
    delVisible.value = false;
  }
};
const save = (str: string): void => {
  if (str === 'add') {
    addVisible.value = false;
  } else if (str === 'del') {
    delVisible.value = false;
  }
  store.dispatch('ticket/selectdepartments');
};

/**
 * 控制到期时间比当前时间晚
 * @param {*} curValue 到期时间
 * @returns {*} 函数
 */
const disabledCheckDate = (curValue: any): any => {
  const { issue, } = Form;

  if (!curValue) {
    return false;
  }

  return curValue.format('YYYY-MM-DD').valueOf() > moment().format('YYYY-MM-DD').valueOf();
};


const handleCancle = ():void => {
  addVisible.value = false;
  delVisible.value = false;
  emits('cancal');
  Object.assign(Form, resetData());
};

const handleSave = () => {
  if (!Form.street) {
    return message.warning('请选择所在街道！');
  }

  if (Form.companyName === '') {
    return message.warning('请输入企业名称！');
  }

  if (Form.projectNumber === '') {
    return message.warning('请输入项目编号！');
  }
  if (Form.projectName === '') {
    return message.warning('请输入工程项目名称！');
  }
  if (Form.projectContent === '') {
    return message.warning('请输入工程项目内容！');
  }
  if (Form.completion === '') {
    return message.warning('请选择完成情况！');
  }
  if (!Form.startTime) {
    return message.warning('请选择开始时间！');
  }
  if (!Form.endTime) {
    return message.warning('请选择结束时间！');
  }
  const params = {
    street: Form.street,
    companyName: Form.companyName,
    projectNumber: Form.projectNumber,
    projectName: Form.projectName,
    projectContent: Form.projectContent,
    completion: Form.completion,
    startTime: moment(Form.startTime).format('YYYY-MM-DD'),
    endTime: moment(Form.endTime).format('YYYY-MM-DD'),
  };

  // 通过id判断更新、新增
  if (Form.id) {
    params.id = Form.id;
  }

  addOrUpdateProject(params).then(() => {
    emits('save');
    Object.assign(Form, resetData());
  }).catch(() => {
    // console.log(error);
  });
};

const addDep = () => {
  addVisible.value = true;
};

const delDep = () => {
  delVisible.value = true;
};

// 监听选择的信息，并赋值
watch(
  () => props.itemInfo,
  (newValue) => {
    if (!Object.keys(newValue).length) {
      return;
    }
    const {
      street, companyName, projectNumber, projectName,projectContent, completion,startTime,endTime, id,
    } = newValue;

    Form.street = street || '';
    Form.companyName = companyName || '';
    Form.projectNumber = projectNumber || '';
    Form.projectName = projectName || '';
    Form.projectContent = projectContent || '';
    Form.completion = completion || '';
    Form.startTime = startTime || '';
    Form.endTime = endTime || '';
    Form.id = id || '';
  },
  {
    deep: true,
    immediate: true,
  }
);


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Modal), {
      getContainer: () => _ctx.$refs.userNewModel,
      title: _unref(Form).id?'更新':'新建',
      width: '4.2rem',
      footer: false,
      visible: props.createVisible,
      onCancel: handleCancle
    }, {
      closeIcon: _withCtx(() => [
        _hoisted_2
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_unref(Select), {
              value: _unref(Form).street,
              "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_unref(Form).street) = $event)),
              placeholder: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.streetList, (val, idx) => {
                  return (_openBlock(), _createBlock(_unref(Option), {
                    key: idx,
                    value: val
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(val), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_6, [
            _hoisted_7,
            _createVNode(_unref(Input), {
              value: _unref(Form).companyName,
              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_unref(Form).companyName) = $event)),
              placeholder: ""
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createVNode(_unref(Input), {
              value: _unref(Form).projectNumber,
              "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_unref(Form).projectNumber) = $event)),
              placeholder: ""
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createVNode(_unref(Input), {
              value: _unref(Form).projectName,
              "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_unref(Form).projectName) = $event)),
              placeholder: ""
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _hoisted_13,
            _createVNode(_unref(Input), {
              value: _unref(Form).projectContent,
              "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_unref(Form).projectContent) = $event)),
              placeholder: ""
            }, null, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createVNode(_unref(Select), {
              value: _unref(Form).completion,
              "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_unref(Form).completion) = $event)),
              placeholder: ""
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.statusList, (val, idx) => {
                  return (_openBlock(), _createBlock(_unref(Option), {
                    key: idx,
                    value: val
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(val), 1)
                    ]),
                    _: 2
                  }, 1032, ["value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["value"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _hoisted_17,
            _createVNode(_unref(ConfigProvider), { locale: _unref(zhCN) }, {
              default: _withCtx(() => [
                _createVNode(_unref(DatePicker), {
                  value: _unref(Form).startTime,
                  "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_unref(Form).startTime) = $event)),
                  format: "YYYY-MM-DD"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["locale"])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createVNode(_unref(ConfigProvider), { locale: _unref(zhCN) }, {
              default: _withCtx(() => [
                _createVNode(_unref(DatePicker), {
                  value: _unref(Form).endTime,
                  "onUpdate:value": _cache[7] || (_cache[7] = ($event: any) => ((_unref(Form).endTime) = $event)),
                  format: "YYYY-MM-DD"
                }, null, 8, ["value"])
              ]),
              _: 1
            }, 8, ["locale"])
          ])
        ]),
        _createElementVNode("div", { class: "operation" }, [
          _createElementVNode("button", {
            class: "btn cancle",
            onClick: handleCancle
          }, "取消"),
          _createElementVNode("button", {
            class: "btn",
            onClick: handleSave
          }, "保存")
        ])
      ]),
      _: 1
    }, 8, ["getContainer", "title", "width", "visible"])
  ], 512))
}
}

})